module.exports = ".break-word {\n    word-wrap: break-word;\n}\n\n.card-body {\n    color: #FFFFFF;\n}\n\n.links-card .card-header {\n    background-color: #0C9688;\n}\n\n.links-card {\n    background-color: #0C9688;\n}\n\n.links-card .row:nth-child(odd) {\n    background-color: #0C9B8E;\n}\n\n.icon {\n    max-height: 30px;\n    min-height: 30px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/link-portal/link-portal.component.css
// module id = 907
// module chunks = 4